/**
 * @file
 * String utilities.
 */


const $string = {

    /** @ignore - DEPRECATED */
    toNumber(str) {
        if (typeof str === 'number') {
            return str;
        } else if (typeof str === 'string') {
            const part = str.match(/^([+-]?)([\d,]+)(\.\d*)?([KMBTPE%]?)$/);
            if (part) {
                const factor = {
                    '+': 1,
                    '-': -1,
                    '': 1
                }[part[1]] * {
                    'K': 1E3,
                    'M': 1E6,
                    'B': 1E9,
                    'T': 1E12,
                    'P': 1E15,
                    'E': 1E18,
                    '%': .01,
                    '': 1
                }[part[4]];
                // This way avoids precision errors
                if (part[3]) {
                    return parseInt(part[2].replace(/,/g, '')) * factor + parseFloat(part[3]) * factor;
                } else {
                    return parseInt(part[2].replace(/,/g, '')) * factor;
                }
            }
        }
        return NaN;
    },


    /**
     * Escape characters to be used in a regular expression.
     * @param {string} str - Raw string to be escaped.
     */
    escapeRegex(str) {
        return $string.escapeUnicode(str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&'));
    },


    /**
     * Convert characters outside ASCII range to \xxxx format.
     * @param {string} str - Raw string to be escaped.
     */
     escapeOracle(str) {
        return ('' + str)
            .replace(/[^\0-~]/g, ch =>
                '\\' + ('000' + ch.charCodeAt().toString(16)).slice(-4));
    },


    /**
     * Unescape characters in \xxxx format.
     * @param {string} str - Escaped string to be unescaped.
     */
     unescapeOracle(str) {
        return ('' + str)
            .replace(/\\([\da-f]{4})/ig, (all, code) =>
                String.fromCharCode(parseInt(code, 16)));
    },


    /**
     * Convert characters outside ASCII range to \uxxxx format.
     * @param {string} str - Raw string to be escaped.
     */
    escapeUnicode(str) {
        return ('' + str)
            .replace(/[^\0-~]/g, ch =>
                '\\u' + ('000' + ch.charCodeAt().toString(16)).slice(-4));
    },


    /**
     * Unescape characters in \uxxxx format.
     * @param {string} str - Escaped string to be unescaped.
     */
    unescapeUnicode(str) {
        return ('' + str)
            .replace(/\\u([\da-f]{4})/ig, (all, code) =>
                String.fromCharCode(parseInt(code, 16)));
    },


    /**
     * Escape <, >, and & using HTML escape sequences.
     * @param {string} str - Raw string to be escaped.
     */
    escapeHTML(str) {
        return str == null ? str : ('' + str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    },


    /**
     * Unescape all HTML escape sequences.
     * @param {string} str - Escaped string to be unescaped.
     */
    unescapeHTML(str) {
        return new DOMParser().parseFromString(str, 'text/html').documentElement.textContent;
    }
}


export default $string;
